import React from 'react';
import PropTypes from 'prop-types';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_ERROR_MULTIPLE_SUBSCRIPTION_TITLE,
	ONBOARDING_ERROR_MULTIPLE_SUBSCRIPTION_DESCRIPTION,
	ONBOARDING_ERROR_CANCELLATION_PERIOD_CTA,
} from '../../../../constants/Copy';
import { ROUTE_HOME } from '../../../../constants/Routes';

const DefaultMultipleSubscription = (props) => (
	<FullPageMessage
		button={{
			onClick: () => props.history.push(ROUTE_HOME),
			testValue: ROUTE_HOME,
			text: ONBOARDING_ERROR_CANCELLATION_PERIOD_CTA,
		}}
		title={ONBOARDING_ERROR_MULTIPLE_SUBSCRIPTION_TITLE}
		description={ONBOARDING_ERROR_MULTIPLE_SUBSCRIPTION_DESCRIPTION}
	/>
);

DefaultMultipleSubscription.propTypes = {
	history: PropTypes.object.isRequired,
};

export default DefaultMultipleSubscription;
